/**
 * HOOF campaign interactions: header scroll, sticky buy, purchase sheet, scenarios.
 */
(function () {
  const PRODUCT_SECTION_ID = 'basketball-product';
  const OPEN_SHEET_EVENT = 'hoof:open-purchase-sheet';

  function initHeader() {
    const header = document.querySelector('[data-hoof-header]');
    if (!header) return;

    const onScroll = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    header.querySelector('[data-hoof-logo]')?.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  function initStickyBuy() {
    const sticky = document.querySelector('[data-hoof-sticky]');
    const target = document.getElementById(PRODUCT_SECTION_ID);
    if (!sticky || !target) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        const scrolledPast = entry.boundingClientRect.bottom <= 0;
        sticky.classList.toggle('is-visible', !entry.isIntersecting && scrolledPast);
      },
      { threshold: 0 }
    );
    observer.observe(target);

    sticky.querySelector('[data-hoof-sticky-cta]')?.addEventListener('click', () => {
      // Opens the primary (first) product buy sheet — homepage 3-Pack.
      window.dispatchEvent(new CustomEvent(OPEN_SHEET_EVENT));
    });
  }

  function initScenarios() {
    const scroller = document.querySelector('[data-hoof-scenarios-scroller]');
    const bar = document.querySelector('[data-hoof-scenarios-progress]');
    if (!scroller || !bar) return;

    const update = () => {
      const max = scroller.scrollWidth - scroller.clientWidth;
      const progress = max <= 0 ? 0 : scroller.scrollLeft / max;
      bar.style.left = `${progress * (100 - 35)}%`;
    };
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initHeroCta() {
    document.querySelectorAll('[data-hoof-scroll-product]').forEach((btn) => {
      btn.addEventListener('click', () => {
        document.getElementById(PRODUCT_SECTION_ID)?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initHeader();
    initStickyBuy();
    initScenarios();
    initHeroCta();
  });
})();
